/*
 *@providesModule SyncUtils
 *
 */

import {Platform} from 'react-native';
import SKZConstants from 'SKZConstants';
import Preferences from 'Preferences';
import ClientPropertyConstants from 'ClientPropertyConstants';

const SEC_PER_MIN = 60;
const IS_CURRENTLY_MATCHMAKING = 'isCurrentlyMatchmaking';

export default class SyncUtils {
  static convertIntToMinSec(time: number): string {
    const mins = Math.floor(time / SEC_PER_MIN);
    let sec = '' + (time % SEC_PER_MIN);
    if (sec.length === 1) {
      sec = '0' + sec;
    }
    return '' + mins + ':' + sec;
  }

  static convertTimeToInt(time: string): number {
    const index = time.indexOf(':');
    return (
      parseInt(time.substring(0, index)) * SEC_PER_MIN +
      parseInt(time.substring(index + 1, time.length))
    );
  }

  static getCurrentTimeInSecs(): number {
    return Math.floor(Date.now() / SKZConstants.MS_PER_SEC);
  }

  // Android-only in-memory matchmaking flag when Sync 1vN is enabled
  private static androidInMemoryMatchmakingFlag: boolean = false;

  private static useAndroidInMemory(): boolean {
    return Platform.OS === 'android' && ClientPropertyConstants.getSync1vNEnabled();
  }

  static setMatchmakingActive(active: boolean): void {
    if (SyncUtils.useAndroidInMemory()) {
      SyncUtils.androidInMemoryMatchmakingFlag = active;
      if (!active) {
        Preferences.set({[IS_CURRENTLY_MATCHMAKING]: false});
      }
      return;
    }
    Preferences.set({[IS_CURRENTLY_MATCHMAKING]: active});
  }

  static isMatchmakingActive(): boolean {
    if (SyncUtils.useAndroidInMemory()) {
      return SyncUtils.androidInMemoryMatchmakingFlag;
    }
    return Preferences.get(IS_CURRENTLY_MATCHMAKING);
  }
}
